import { Form, Formik } from 'formik'

import { useAccount, useCreateCheckoutSession, useUpgradeSubscription } from 'src/hooks'
import { BillingForm } from './billing-form.component'
import { EAccountSubscriptionPlans, EPaymentMethod, IBillingModalFormValues } from 'src/types'

interface IBillingFormWrapperProps {
  subscription_plan: EAccountSubscriptionPlans | null
  onClose: () => void
}

const BillingFormWrapper = ({ subscription_plan, onClose }: IBillingFormWrapperProps) => {
  const { mutateAsync: createSession } = useCreateCheckoutSession()
  const { mutate: upgrade } = useUpgradeSubscription()
  const { data: account } = useAccount()

  if (!account) return null

  const handleSubscribe = async (subscription_plan: EAccountSubscriptionPlans, months: number) => {
    const link = await createSession({ subscription_plan, months })
    link && window.open(link, '_self')
  }

  const handleUpgrade = (subscription_plan: EAccountSubscriptionPlans, months: number) => {
    upgrade({ subscription_plan, months })
  }

  const handleSubmit = async (values: IBillingModalFormValues) => {
    if (values.method === EPaymentMethod.Crypto) {
      return onClose()
    }

    if (account.subscription_plan === EAccountSubscriptionPlans.plus) {
      handleUpgrade(values.subscription_plan, values.months)
      return onClose()
    }

    await handleSubscribe(values.subscription_plan, values.months)
    onClose()
  }

  return (
    <Formik
      initialValues={{
        months: 1,
        method: EPaymentMethod.Card,
        subscription_plan:
          subscription_plan ??
          (account.subscription_plan === EAccountSubscriptionPlans.plus
            ? EAccountSubscriptionPlans.premium
            : EAccountSubscriptionPlans.plus),
      }}
      onSubmit={handleSubmit}
    >
      <Form>
        <BillingForm onClose={onClose} subscription_plan={subscription_plan} />
      </Form>
    </Formik>
  )
}

export { BillingFormWrapper }
